// extracted by mini-css-extract-plugin
export default {"image":"S1-z","loaded":"T1-z","placeholder":"U1-z"};